import { render, staticRenderFns } from "./SubGroupList.vue?vue&type=template&id=05a10d1d"
import script from "./SubGroupList.vue?vue&type=script&lang=js"
export * from "./SubGroupList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports